/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import appRoutes from "../../routes/appRoutes";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import ICCheckbox from "../../components/form/checkbox";
// import Anchor from "../../components/anchor";
import { NavLink } from "react-router-dom";

const LoginForm = props => {

  // const loginDisabled = props.userSubscribed && props.userSubscribed.oneSignalSubscribed && props.userSubscribed.oneSignalSubscribed.isSubscribed ? false : true;  

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      deviceType: 2,
      // deviceToken: !loginDisabled ? props.userSubscribed.oneSignalSubscribed.oneSignalId : "",
      deviceToken: "a3032435-e665-4118-aaca-7aec9531c96e",
      rememberMeCheckbox: false
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter the email address"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters long")
        .required("Please enter the password")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form
      className="d-flex flex-column align-items-center"
      onSubmit={formik.handleSubmit}
    >
      <ICInput
        id="email"
        name="email"
        type="text"
        label="Email Address *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        error={formik.touched.email && formik.errors.email ? true : false}
        helperText={
          formik.touched.email && formik.errors.email ? formik.errors.email : ""
        }
      />
      <br />
      <ICInput
        id="password"
        name="password"
        type="password"
        label="Password *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.password}
        error={formik.touched.password && formik.errors.password ? true : false}
        helperText={
          formik.touched.password && formik.errors.password
            ? formik.errors.password
            : ""
        }
      />
      <NavLink
        to={appRoutes.forgotPassword}
        className="lg-forgot-button insta-link-orange text-decoration-none"
        href="/"
      >
        <span className="ml-2 pt-1">Forgot?</span>
      </NavLink>
      {/* <Anchor
        title="Forgot?"
        className="lg-forgot-button insta-link-orange"
        href={appRoutes.forgotPassword}
      /> */}
      <div className="rm-forget-container d-flex flex-row justify-content-between align-items-center flex-wrap">
        <p>
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="rememberMeCheckbox"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.rememberMeCheckbox}
            inputProps={{ "aria-label": "primary checkbox" }}
            label="Remember Me"
          />
        </p>
      </div>
      <br />      
      {/* <Button title="Login" type="submit" disabled={props.mobile || props.browserNotCompatable || loginDisabled} /> */}
      <Button title="Login" type="submit" disabled={props.browserNotCompatable} />
      <br />
      <Error>{props.serverErrorMsg}</Error>
    </form>
  );
};

// export default LoginForm;

const mapStateToProps = props => ({
  userSubscribed: props.commonReducers
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);

LoginForm.defaultProps = {
  serverErrorMsg: ""
};

LoginForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
